<template>
  <v-content>
    <iframe
      id="textfile"
      name="textfile"
      style="width: 0px; height: 0px; border: 0; border: none; display: none"
      src
    ></iframe>

    <div v-show="false" style="width: 300px"></div>
    <v-row no-gutters>
      <v-col
        v-show="true"
        cols="12"
        xl="6"
        lg="6"
        md="6"
        sm="6"
        xs="12"
      >
        <v-flex class="pb-2 ml-2">
          <v-alert
            dense
            color="topPedidos"
            class="white--text"
            style="font-size: 20px"
            border="bottom"
            >PEDIDOS EM ABERTOS</v-alert
          >
          <div>
            <v-progress-linear
              v-if="carregaRecebidos"
              indeterminate
              color="blue darken-2"
            ></v-progress-linear>
            <v-simple-table :height="heightTable">
              <template v-slot:default>
                <thead></thead>
                <tbody>
                  <tr v-for="item in itensRecebidos" :key="item.name">
                    <td class="text-left">
                      <v-row no-gutters>
                        <v-col cols="12" xl="10" lg="8" md="8" sm="8" xs="8">
                          <v-row no-gutters>
                            <v-col
                              cols="12"
                              xl="12"
                              lg="12"
                              md="12"
                              sm="12"
                              xs="12"
                              style="font-weight: bolder"
                            >
                              <p
                                class="text-left"
                                style="
                                  padding-left: 0px;
                                  margim-bottom: 0px;
                                  font-weight: bolder;
                                "
                              ></p>
                              Pedido: {{ item.id }} - Mesa : {{ item.mesa }} - Comanda : {{ item.num_comanda }}
                            </v-col>
                            <v-col
                              cols="12"
                              xl="12"
                              lg="12"
                              md="12"
                              sm="12"
                              xs="12"
                            >
                              <p
                                style="
                                  padding-left: 0px;
                                  margim-bottom: 0px;
                                  font-size: 0.9em;
                                "
                              >
                                {{ item.nome }} - {{ item.data }}
                                {{ item.hora }}
                              </p>
                            </v-col>
                          </v-row>
                        </v-col>
                        <v-col
                          class="text-right"
                          cols="10"
                          xl="3"
                          lg="4"
                          md="4"
                          sm="4"
                          xs="4"
                        >
                         <!-- <v-btn  @click="muda_status(item.id, 2)"
                            depressed
                            color="topEnviados"
                            fab
                            x-small
                            dark
                          >
                            <v-icon>mdi-check</v-icon>
                          </v-btn> -->
                          <v-btn v-if="item.status =='Cancelado'"
                            color="error"
                            text
                            tile
                            x-small
                          >Cancelado</v-btn>
                          
                          <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                v-if="item.status !='Cancelado'"
                                  @click="cancela(item.id)"
                                  depressed
                                  color="delete"
                                  fab
                                  x-small
                                  dark
                                  v-bind="attrs"
                                v-on="on"
                                >
                                  <v-icon>mdi-delete-outline</v-icon>
                                </v-btn>
                              </template>
                              <span>Cancelar Pedido</span>
                         </v-tooltip>
                         <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }">
                          <v-btn
                          v-if="item.status !='Cancelado'"
                            @click="ver_detalhe(item, item.id, item.itens)"
                            depressed
                            color="btBlue"
                            fab
                            x-small
                            dark
                            v-bind="attrs"
                             v-on="on"
                          >
                            <v-icon>mdi-loupe</v-icon>
                          </v-btn>
                        </template>
                              <span>Ver detalhes do  Pedido</span>
                         </v-tooltip>
                          <!---
                          <v-btn
                            @click="imprimir(item)"
                            depressed
                            color="print"
                            fab
                            x-small
                            dark
                          >
                            <i class="material-icons">local_print_shop</i>
                          </v-btn>-->
                        </v-col>
                      </v-row>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </div>
        </v-flex>
      </v-col>

      <v-col
        v-show="true"
        cols="12"
        xl="6"
        lg="6"
        md="6"
        sm="6"
        xs="12"
      >
        <v-flex class="pb-2 ml-3">
          <v-alert
            dense
            color="topEnviados"
            style="font-size: 20px"
            class="white--text"
            border="bottom"
            >BAIXADOS
          </v-alert>
          <div>
            <v-progress-linear
              v-if="carregaBaixados"
              indeterminate
              color="blue darken-5"
            ></v-progress-linear>
            <v-simple-table :height="heightTable">
              <template v-slot:default>
                <thead></thead>
                <tbody>
                  <tr v-for="item in itensBaixados" :key="item.name">
                    <td class="text-left">
                      <v-row no-gutters>
                        <v-col cols="12" xl="10" lg="8" md="8" sm="8" xs="8">
                          <v-row no-gutters>
                            <v-col
                              cols="12"
                              xl="12"
                              lg="12"
                              md="12"
                              sm="12"
                              xs="12"
                              style="font-weight: bolder"
                            >
                              <p
                                class="text-left"
                                style="
                                  padding-left: 0px;
                                  margim-bottom: 0px;
                                  font-weight: bolder;
                                "
                              ></p>
                              Pedido: {{ item.id }}  - Mesa : {{ item.mesa }} - Comanda : {{ item.num_comanda }}
                            </v-col>
                            <v-col
                              cols="12"
                              xl="12"
                              lg="12"
                              md="12"
                              sm="12"
                              xs="12"
                            >
                              <p
                                style="
                                  padding-left: 0px;
                                  margim-bottom: 0px;
                                  font-size: 0.9em;
                                "
                              >
                                {{ item.nome }} - {{ item.data }}
                                {{ item.hora }}
                              </p>
                            </v-col>
                          </v-row>
                        </v-col>
                        <v-col
                          class="text-right"
                          cols="10"
                          xl="3"
                          lg="4"
                          md="4"
                          sm="4"
                          xs="4"
                        >
                          <!--<v-btn
                            @click="muda_status(item.id, 2)"
                            depressed
                            color="topEnviados"
                            fab
                            x-small
                            dark
                          >
                            <v-icon>mdi-check</v-icon>
                          </v-btn>-->
                          <v-btn
                            @click="ver_detalhe(item, item.id, item.itens)"
                            depressed
                            color="btBlue"
                            fab
                            x-small
                            dark
                          >
                            <v-icon>mdi-loupe</v-icon>
                          </v-btn>
                          <!---
                          <v-btn
                            @click="imprimir(item)"
                            depressed
                            color="print"
                            fab
                            x-small
                            dark
                          >
                            <i class="material-icons">local_print_shop</i>
                          </v-btn>-->
                        </v-col>
                      </v-row>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </div>
        </v-flex>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-dialog v-model="dialogCancel" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">Cancelamento Pedido</v-card-title>
          <v-card-text>Deseja cancelar este pedido?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="red darken-1"
              class="white--text"
              @click="dialogCancel = false"
              >Não</v-btn
            >
            <v-btn
              color="green darken-1"
              class="white--text"
              @click="cancela_pedido()"
              >Sim</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogCancelItem" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">Cancelamento Pedido</v-card-title>
          <v-card-text>Deseja cancelar este Item?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="red darken-1"
              class="white--text"
              @click="dialogCancelItem = false"
              >Não</v-btn
            >
            <v-btn
              color="green darken-1"
              class="white--text"
              @click="cancelaItemPedido()"
              >Sim</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <v-row justify="center">
      <v-dialog v-model="dialogItens" max-width="590">
        <v-card>
          <v-card-title>
            <v-row style="max-width=590px;background-color:#CCC">
              <v-col class="pl-2" cols="6">
                <p class>
                  ITENS PEDIDOS -
                  <span class="pl-1">{{ itemPedidoSel }}</span>
                </p>
                Mesa - <span>{{ mesasel }}</span>
              </v-col>
              <v-col class="pl-2 pt-2 pb-2" cols="6">
                <div style="text-align: right">
                
<!--
                  <v-btn
                    @click="imprimir(itemSel)"
                    depressed
                    color="print"
                    fab
                    x-small
                    dark
                  >
                    <i class="material-icons">local_print_shop</i>
                  </v-btn>-->
                  <v-btn
                    @click="dialogItens = false"
                    depressed
                    color="primary"
                    fab
                    x-small
                    dark
                  >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </div>
              </v-col>
            </v-row>
          </v-card-title>

          <v-row class="ml-2 text-left">
            <v-col cols="4">Cliente: {{ itemSel.nome }}</v-col>
            <v-col cols="4">Tel: {{ itemSel.telefone }}</v-col>
          </v-row>
          <v-row v-if="itemSel.retirar_local == 0" class="ml-2 text-left">
            <v-col cols="6">Endereço: {{ endereco_entrega.logradouro }}</v-col>
            <v-col cols="2">Nº: {{ endereco_entrega.numero }}</v-col>
            <v-col col="2">Cep: {{ endereco_entrega.cep }}</v-col>
            <v-col cols="6">Bairro: {{ endereco_entrega.bairro }}</v-col>
          </v-row>
          <v-row v-if="itemSel.retirar_local == 1" class="ml-2 text-left">
            <v-col cols="6">Retirar no local</v-col>
          </v-row>

          <v-simple-table
            style="margin: 15px !important"
            :dense="dense"
            :fixed-header="fixedHeader"
            :height="heightTable"
          >
            <template v-slot:default>
              <thead>
                <th>Produto</th>
                <th>Qtde.</th>
                <th>Obs.</th>
                <th>Cancelar Item</th>
              </thead>
              <tbody>
                <tr v-for="item in itensDetalhe" :key="item.nome">
                  <td style="text-align: left">
                    {{ item.codigo }} - {{ item.descricao_reduzida }}
                  </td>
                  <td>{{ item.qtde }}</td>
                  <td>{{ item.obs }}</td>
                  <td>
                    <v-btn
                    v-show="$can('admin.loja|pedido.itens.cancelar')"
                               
                                  @click="cancelaItem(item.id)"
                                  depressed
                                  color="delete"
                                  fab
                                  x-small
                                  dark
                                
                                >
                                  <v-icon>mdi-delete-outline</v-icon>
                                </v-btn></td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card>
      </v-dialog>
    </v-row>
  </v-content>
</template>

<script>
var moment = require("moment");

const auth = {
  headers: {
    Authorization: "bearer " + window.sessionStorage.getItem("token"),
  },
};
export default {
  props: {
    source: String,
  },
  mounted() {
    this.buscaAlarme();
    this.buscaPedidosAbertos();
    this.buscaPedidosBaixados();
    //clearInterval(buscaPedidos);
    setInterval(() => {
      this.buscaPedidosAbertos();
      this.buscaPedidosBaixados();
    }, 30000);
  },
  data: (vm) => ({

    audio: new Audio("https://api.cardapio.ommini.com.br/beep2.mp3"),
    carregaRecebidos: true,
    carregaPreparando: true,
    carregaBaixados: true,
    carregaBaixadosEnviados: true,
    date_ini: new Date().toISOString().substr(0, 10),
    date_fim: moment().format("YYYY-MM-01"),
    dateFimFormatted: vm.formatDate(new Date().toISOString().substr(0, 10)),
    dateIniFormatted: moment().format("01/MM/YYYY"),
    menu1: false,
    menu2: false,
    loading_table: false,
    headers: [],
    search: "",
    loading_filtrar: false,
    loading_baixar: false,
    items: [],
    heightTable: 550,
    itensRecebidos: [],
    itensPreparando: [],
    itensBaixados: [],
    itensDetalhe: [],
    dialogItens: false,
    dialogCancel: false,
    id_cancela: "",
    dialogCancelItem: false,
    id_cancelaItem: "",
    
    cf: "",
    mesasel:"",
    dense: true,
    itemSel: [],
    itemPedidoSel:"",
    endereco_entrega: "",
    fixedHeader: true,
    on:true,
    attrs:"",
    headers: [
      {
        text: "Chave",
        sortable: true,
        align: "left",
        value: "chave",
      },
      {
        text: "Data",
        value: "data",
      },
      {
        text: "Número",
        value: "nf_numero",
        align: "right",
      },
      {
        text: "Status",
        value: "status",
        sortable: false,
      },
    ],
  }),
  computed: {
    computedDateInFormatted() {
      return this.formatDate(this.date_ini);
    },
    computedDateFimFormatted() {
      return this.formatDate(this.date_fim);
    },
  },

  watch: {
    date_ini(val) {
      this.dateIniFormatted = this.formatDate(this.date_ini);
    },
    date_fim(val) {
      this.dateFimFormatted = this.formatDate(this.date_fim);
    },
  },
  methods: {
    tocar_som() {
      this.audio.play();
      setTimeout(() => {
        this.pauser_som();
      }, 15000);
    },
    pauser_som() {
      this.audio.pause();
    },
    ver_detalhe(item, id_pedido, itens) {
      this.itemPedidoSel = id_pedido;
      this.mesasel  = item.mesa;
      this.itensDetalhe = itens;
      this.itemSel = item;
      this.endereco_entrega = item.endereco_entrega;
      this.dialogItens = true;
    },
    cancela(id) {
      this.dialogCancel = true;
      this.id_cancela = id;
    },
    cancelaItem(id) {
      this.dialogCancelItem = true;
      this.id_cancelaItem = id;
    },
    cancela_pedido() {
      this.dialogCancel = false;
      this.dialogItens = false;
      this.muda_status(this.id_cancela, 8);
      this.id_cancela = "";
    },
    cancelaItemPedido(){
      this.dialogCancelItem = false;
      
      axios
        .post(`/pedido/cancelar_item`, {
          id: this.id_cancelaItem
          
        })
        .then((response) => {
          if (response.data.error) {
            this.textSnack = response.data.error;
            this.snackbar = true;
          } else {
            this.buscaPedidosAbertos();
            this.dialogItens = false
            // this.buscaPedidosRecebidos();
            //  this.buscaPedidosPreparando();
            //  this.buscaPedidosEnviados();
          }
        });
    },
    
    muda_status(id, status) {
      if (status === 2) {
        this.pauser_som();
      }
      axios
        .post(`/pedido/status/`, {
          id: id,
          id_status: status,
        })
        .then((response) => {
          if (response.data.error) {
            this.textSnack = response.data.error;
            this.snackbar = true;
          } else {
            // this.buscaPedidosRecebidos();
            //  this.buscaPedidosPreparando();
            //  this.buscaPedidosEnviados();
          }
        });
    },
    imprimir(item) {
      this.loading_baixar = true;

      axios
        .post(`/pedido/imprimir`, {
          pedido: item,
        })
        .then((response) => {
          if (response.data.error) {
            this.textSnack = response.data.error;
            this.snackbar = true;
            alert("erro");
          } else {
            this.loading_baixar = false;
            // document.getElementById("linkDownload").innerHTML = response.data;

            textfile;

            let iframe;

            iframe = document.getElementById("textfile");
            iframe.setAttribute("src", "");
            // iframe.setAttribute("src", response.data.url);
            iframe.setAttribute("src", response.data.url);

            //  printJS("http://localhost:8080/Delivery.pdf");
            setTimeout(() => {
              iframe.focus();
              iframe.contentWindow.print();
            }, 1000);
          }
        });
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [day, month, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    getStatus(status) {
      if (status === "Cancelada") {
        return "cancelada";
      }
    },
    baixar_notas() {
      this.loading_baixar = true;

      axios
        .post(`/nfentrada/arquivos/baixar`, {
          cnpj: window.sessionStorage.getItem("cnpj"),
          data_ini: this.date_ini,
          data_fim: this.date_fim,
        })
        .then((response) => {
          if (response.data.error) {
            this.textSnack = response.data.error;
            this.snackbar = true;
          } else {
            this.loading_baixar = false;
            setTimeout(() => {
              // document.getElementById("linkDownload").href = response.data.url;
              //document.getElementById("linkDownload").download =
              // '"http://192.168.1.135:75/GKFq70ibiI38urfHml.pdf"';
              document.getElementById("linkDownload").click();
            }, 600);
          }
        });
    },
     buscaAlarme() {
      axios.get(`/config/lista`).then((response) => {
        if (response.data.error) {
          //  this.textSnack = response.data.error;
          //  this.snackbar = true;
        } else {
          sessionStorage.setItem(
            "alarme",
            response.data.alerta_sonoro_pedido_recebido
          );
          // console.log(response.data);
        }
      });
    },
    buscaPedidosAbertos() {
      this.carregaRecebidos = true;
      axios
        .get(`pedido/lista_abertos`, {
          dataIn: this.dataIn,
          dataFim: this.dataFim,
          cliente: this.cliente,
          produto: this.produto,
        })
        .then((response) => {
          if (response.data.error) {
            this.textSnack = response.data.error;
            this.snackbar = true;
          } else {
            //this.extrato =
            //console.log(response.data);
            this.itensRecebidos = response.data;
              if (this.itensRecebidos.length > 0) {
              //console.log('alarm1'+sessionStorage.getItem("alarme"));
              if (sessionStorage.getItem("alarme") !== false) {
              //  alert('alarme tocar')
                this.tocar_som();
              }
              //
            }

          }
          this.carregaRecebidos = false;
        });
    },
    buscaPedidosBaixados() {
      self = this;
      self.carregaBaixados = true;

      axios
        .get(`pedido/lista_baixados`, {
          dataIn: this.dataIn,
          dataFim: this.dataFim,
          cliente: this.cliente,
          produto: this.produto,
        })
        .then((response) => {
          if (response.data.error) {
            this.textSnack = response.data.error;
            this.snackbar = true;
          } else {
            //this.extrato =
            console.log(response.data);
            if (response.data == "") {
            }
            this.itensBaixados = response.data;
          }
        })
        .catch(function(error) {
          console.log(error);
        })
        .then(function() {
          self.carregaBaixados = false;
        });
    },
    buscaPedidosRecebidos() {
      this.carregaRecebidos = true;

      axios
        .get(`pedido/recebido`, {
          dataIn: this.dataIn,
          dataFim: this.dataFim,
          cliente: this.cliente,
          produto: this.produto,
        })
        .then((response) => {
          if (response.data.error) {
            this.textSnack = response.data.error;
            this.snackbar = true;
          } else {
            //this.extrato =
            console.log(response.data);
            this.itensRecebidos = response.data;
            if (this.itensRecebidos.length > 0) {
              //  this.tocar_som();
            }
            this.carregaRecebidos = false;
          }
        })
        .catch(function(error) {
          console.log(error);
        })
        .then(function() {
          //this.carregaRecebidos = false;
        });
    },
  },
};
</script>
<style scoped>
.cancelada {
  color: red;
}

.container {
  margin-left: 0px !important;
  margin-right: 0px !important;
}
.v-data-table td,
.v-data-table th {
  padding: 0 0px !important;
}
.v-alert {
  margin-bottom: 0px !important;
  padding-top: 2px !important;
  line-height: 25px !important;
}
.v-btn {
  margin-left: 5px !important;
}
</style>
